import type { StatusIndicatorVariantKey } from '@components/status-indicator';

type ActionState = {
  isSkipped?: boolean;
  isHalted?: boolean;
  isError?: boolean;
  isCompleted?: boolean;
  isInProgress?: boolean;
};

export const getStatusIndicatorVariant = ({
  isSkipped,
  isHalted,
  isError,
  isCompleted,
  isInProgress,
}: ActionState): StatusIndicatorVariantKey => {
  if (isSkipped) return 'skipped';
  if (isHalted && !isError) return 'halted';
  if (isError) return 'error';
  if (isCompleted) return 'completed';
  if (isInProgress) return 'inProgress';
  return 'notStarted';
};
